<template>
  <div class="lstdisk">
    <div style="display:flex">
      <disk
        v-for="disk in disks"
        @click="setSelected(disk)"
        :selected="selected == disk"
        :key="disk.id"
        :disk="disk"
      />
    </div>
    <button class="button" v-show="showSelect" @click="startSelectedDisk">
      {{ $t("general.confirm") }}
    </button>
  </div>
</template>

<script>
import disk from "./Disk.vue";
export default {
  props: ["disks", "selected"],
  data() {
    return {
      showSelect: false,
    };
  },
  components: { disk },
  methods: {
    setSelected(disk) {
      this.showSelect = true;
      this.$emit("selected", disk);
    },
    startSelectedDisk() {
      this.$emit("start");
    },
  },
};
</script>

<style lang="scss" scoped>
.lstdisk {
  display: flex;
  flex-direction: column;
}
.button {
  background-color: #4caf50; /* Green */
  border: none;
  color: white;
  padding: 15px 32px;
  text-align: center;
  text-decoration: none;
  display: inline-block;
  font-size: 16px;
  margin: 4px 2px;
  cursor: pointer;
}
</style>
